import { getData, putData, postData } from "../utils/api";

const SMTP_ENDPOINT = "/data/settings/smtp";

/**
 * Fetch current SMTP configuration from the API.
 * Returns null if the endpoint is not implemented yet.
 */
export const getSmtpConfig = async () => {
  try {
    const result = await getData(SMTP_ENDPOINT);
    return result?.data ?? null;
  } catch (err) {
    if (err?.status === 404 || err?.message?.toLowerCase?.().includes("not found")) {
      return null;
    }
    throw err;
  }
};

/**
 * Save SMTP configuration via the API.
 */
export const saveSmtpConfig = async (config) => {
  return putData(SMTP_ENDPOINT, config);
};

/**
 * Send a test email using the current SMTP configuration.
 */
export const sendSmtpTestEmail = async (toEmail) => {
  return postData(`${SMTP_ENDPOINT}/test`, { email: toEmail });
}
